<template>
    <div class="">
        <!-- Navbar1  -->
        <div class="d-none d-sm-none d-md-none d-lg-block">
         <b-navbar class="nav1" >
            <router-link 
            :to="{ name: 'Home'}"
            >
            <img class="logo" 
              src="/img/logo-enterprise.png"/>
            </router-link>
            <!-- flag -->
            <router-link 
            :to="{ name: 'Home'}"
            >
            <img class="flag" 
              src="/img/flag.jpg"/>
            </router-link>
            
            <b-navbar-nav class="ml-auto">
              <b-nav-form>
                <b-button 
                squared 
                class="buttonterms mt-1" 
                href=""
                data-toggle="modal" data-target="#policiesModal"
                >{{$t('buttons_label.terms_policies')}}
                </b-button>
                
                <!--  -->
                <p 
                class="text-white dinregular mt-3"
                id="popover-target-total"
                @mouseover="hover = true"
                >
                  <span class="ml-2 border-left border-white"></span>
                  <span class="ml-2 "> total:</span>
                  <span class="ml-2">US$</span>
                  <span v-if="calculo.length == 0" class="totalnav mr-5">0.00</span>
                  <span v-else class="totalnav mr-5">{{calculo.detalle.total}}</span>
                </p>
              </b-nav-form>
            </b-navbar-nav>
          </b-navbar> 
        </div>
        
        <!-- hover card for total -->
        
          <div v-if="hover">
            <b-card
            @mouseleave="hover = false"  
            class="cardtotals text-white " 
            >
            <div class="ml-2 mr-2 border-bottom dinregular">
             <h2 class="">{{$t('hovercard.t1')}}</h2>
             <p>{{$t('hovercard.t2')}}</p>
             <span v-if="calculo.reserva.paquete != null">Paquete {{calculo.reserva.paquete}}</span> 
             <span v-else>{{$t('paquetes.td')}}</span>  
             <span style="float:right;">US${{parseFloat(calculo.detalle.tarifa).toFixed(2)}}</span>
             <br>
             <p class="focusborder mt-2" v-b-toggle.collapse-detailstotals>
              <span class=" textdetailstotals dinbold">{{$t('hovercard.t3')}}</span>
              <img src="/img/arrowdown.png" class="mr-2">
              <span style="float:right;">US${{ calculo.detalle.subtotal }}</span> 
             </p>
             <b-collapse 
                id="collapse-detailstotals" 
                class=""
                style=""
                >
                 <div class="dinregular">
                   <!--coberturas obligatorias-->
                   <b-row v-show="calculo.detalle.cob_obligatoria.monto[0] > 0">
                     
                      <b-col>
                        <p class="float-left" v-if="$i18n.locale==='es'">{{calculo.detalle.cob_obligatoria.nombre[0]}}</p>
                      </b-col>  

                      <b-col>
                        <p class="float-right" >US$ {{parseFloat(calculo.detalle.cob_obligatoria.monto[0]).toFixed(2)}}</p>
                      </b-col> 

                   </b-row> 
                   <b-row v-show="calculo.detalle.cob_obligatoria.monto[1] > 0">
                     
                      <b-col>
                        <p class="float-left" v-if="$i18n.locale==='es'">{{calculo.detalle.cob_obligatoria.nombre[1]}}</p>
                      </b-col>  

                      <b-col>
                        <p class="float-right" >US$ {{parseFloat(calculo.detalle.cob_obligatoria.monto[1]).toFixed(2)}}</p>
                      </b-col> 

                   </b-row> 
                   <!--coberturas obligatorias-->
                   <b-row>
                     <b-col>
                       <span v-for="cobertura in data.coberturas" :key="cobertura.id">
                         <span>{{cobertura.nombre}}</span>
                         <span class="float-right">US$ {{cobertura.monto}}</span><br>
                       </span>
                     </b-col>
                   </b-row>
                   
                   <b-row>
                     <b-col>
                       <span v-for="accesorio in data.accesorios" :key="accesorio.id">
                         <span v-if="accesorio.monto>0">{{accesorio.nombre}}</span>
                         <span v-if="accesorio.monto>0" class="float-right">US$ {{accesorio.monto}}</span><br>
                       </span>
                     </b-col>
                   </b-row>
                   <b-row>
                     <b-col>
                       
                         <span class="spanXtras" v-show="data.conductor_adicional > 0">
                              {{$t('extras.drv2')}}({{data.conductor_adicional}})
                              <span class="float-right">US$ {{ parseFloat(calculo.detalle.conductor_adicional * data.conductor_adicional).toFixed(2) }}</span>
                          </span>
                       
                     </b-col>
                   </b-row>
                   <!--  -->
                   <b-row>
                     <b-col>
                       
                         <span class="spanXtras" v-show="calculo.detalle.dropoff !== '0.00'">
                              Drop Off
                              <span class="float-right">US$ {{ parseFloat(calculo.detalle.dropoff).toFixed(2) }}</span>
                          </span>
                       
                     </b-col>
                   </b-row>
                   <b-row>
                    <b-col class="text-left">
                     <p>{{$t('hovercard.t5')}}</p>
                     <p>Subtotal</p>
                     <p>{{$t('hovercard.t7')}} </p>
                   </b-col>
                   <b-col class="text-right">
                     <p v-if="calculo.detalle.apo_fee != '0.00'">US$ {{calculo.detalle.apo_fee}}</p>
                     <p>US$ {{parseFloat(calculo.detalle.subtotal).toFixed(2)}}</p>
                     <p>US$ {{parseFloat(calculo.detalle.itbm).toFixed(2)}}</p>
                   </b-col>
                   </b-row>
                   
                 </div>
             </b-collapse>
            </div>
            <b-row class="m-1 dinregular">
              <b-col class="text-left">
                {{$t('hovercard.t8')}}
              </b-col>
              <b-col class="text-right">
                US$ {{parseFloat(calculo.detalle.total).toFixed(2)}}
              </b-col>
            </b-row>
            </b-card>
        </div>
        <!-- mobile navbar reserve -->
        <div class="mobilenav  d-lg-none d-xl-none w-100">
          <b-navbar toggleable type="" variant="">
            <b-navbar-brand href="#">
              <router-link :to="{ name: 'Home'}"><img class="iconlogo" 
              src="/img/icon-enterprise.png"/>
              </router-link>
            </b-navbar-brand>
            <b-button 
                squared 
                class="buttonterms mb-2 text-uppercase" 
                style="margin-right:25%;"
                data-toggle="modal" data-target="#policiesModalMobile"
                >{{$t('buttons_label.policies')}}
            </b-button>
            <!-- modal for policies -->
                <div 
                class="modal fade" 
                id="policiesModalMobile" 
                tabindex="-1" 
                aria-labelledby="policies-modal" 
                aria-hidden="true">
                  <div class="modal-dialog modal-md">
                    <div class="modal-content rounded-0">
                      <div 
                      class="modal-header rounded-0" 
                      style="background-color:#169a5a;">
                        <h5 class="modal-title modaltitle" id="policies-modal">{{$t('modalpolicy.pol1')}}</h5>
                        <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close">
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </div>
                      <div class="modal-body">
                        <b-row>
                          <!-- <b-col md="5">
                              <div style="margin-top:-17px"  class="nav flex-column " id="v-pills-tab" role="tablist" aria-orientation="vertical">
                                <a class="btnpolicies nav-link active" id="v-pills-conditions-tab" data-toggle="pill" href="#v-pills-conditions" role="tab" aria-controls="v-pills-conditions" aria-selected="true">
                                  <p class="ml-3">Condiciones de alquiler
                                  <img src="/img/arrowright.png" class="iconpolicy">
                                  </p>
                                </a>
                                <a class="btnpolicies nav-link" id="v-pills-edd-tab" data-toggle="pill" href="#v-pills-edd" role="tab" aria-controls="v-pills-edd" aria-selected="false">
                                  <p class="ml-3">Exoneración del Deducible por Colisión (EDD): 
                                  <img src="/img/arrowright.png" class="iconpolicy">
                                  </p>
                                </a>
                                <a class="btnpolicies nav-link" id="v-pills-clp-tab" data-toggle="pill" href="#v-pills-clp" role="tab" aria-controls="v-pills-clp" aria-selected="false">
                                  <p class="ml-3">Cobertura de Llantas y Parabrisas (CLP): 
                                  <img src="/img/arrowright.png" class="iconpolicy">
                                  </p>
                                </a>
                                <a class="btnpolicies nav-link" id="v-pills-cap-tab" data-toggle="pill" href="#v-pills-cap" role="tab" aria-controls="v-pills-cap" aria-selected="false">
                                  <p class="ml-3">Cobertura de Accidentes Personales (CAP): 
                                  <img src="/img/arrowright.png" class="iconpolicy">
                                  </p>
                                </a>
                                <a class="btnpolicies nav-link" id="v-pills-srd-tab" data-toggle="pill" href="#v-pills-srd" role="tab" aria-controls="v-pills-srd" aria-selected="false">
                                  <p class="ml-3">Super Relevo de Deducible (SRD):
                                  <img src="/img/arrowright.png" class="iconpolicy">
                                  </p>
                                </a>
                                <a class="btnpolicies nav-link" id="v-pills-alt-tab" data-toggle="pill" href="#v-pills-alt" role="tab" aria-controls="v-pills-alt" aria-selected="false">
                                  <p class="ml-3">Ampliación del Límite a Terceros (ALT):
                                  <img src="/img/arrowright.png" class="iconpolicy">
                                  </p>
                                </a>
                                <a class="btnpolicies nav-link" id="v-pills-rap-tab" data-toggle="pill" href="#v-pills-rap" role="tab" aria-controls="v-pills-rap" aria-selected="false">
                                  <p class="ml-3">Asistencia en Carretera (RAP):
                                  <img src="/img/arrowright.png" class="iconpolicy">
                                  </p>
                                </a>
                              </div>
                          </b-col> -->
                          <b-col md>
                            <div class="tab-content" id="v-pills-tabContent">
                              <div class="tab-pane fade show active" id="v-pills-conditions" role="tabpanel" aria-labelledby="v-pills-conditions-tab">
                                <p 
                                class="titletermsmodal"
                                style="border-bottom: solid 2px #000000 !important;"
                                >{{$t('modalpolicy.pol2')}}</p>
                                <renttermscomp/>
                              </div>
                              <div class="tab-pane fade" id="v-pills-edd" role="tabpanel" aria-labelledby="v-pills-edd-tab">
                                <p 
                                class="titletermsmodal"
                                style="border-bottom: solid 2px #000000 !important;"
                                >{{$t('modalpolicy.pol3')}}</p>
                                {{$t('modalpolicy.pol4')}}
                              </div>
                              <div class="tab-pane fade" id="v-pills-clp" role="tabpanel" aria-labelledby="v-pills-clp-tab">
                                <p 
                                class="titletermsmodal"
                                style="border-bottom: solid 2px #000000 !important;"
                                >{{$t('modalpolicy.pol5')}} </p>
                                {{$t('modalpolicy.pol16')}}
                              </div>
                              <div class="tab-pane fade" id="v-pills-cap" role="tabpanel" aria-labelledby="v-pills-cap-tab">
                                <p 
                                class="titletermsmodal"
                                style="border-bottom: solid 2px #000000 !important;"
                                >{{$t('modalpolicy.pol7')}}</p>
                                {{$t('modalpolicy.pol8')}}
                              </div>
                              <div class="tab-pane fade" id="v-pills-srd" role="tabpanel" aria-labelledby="v-pills-srd-tab">
                                <p 
                                class="titletermsmodal"
                                style="border-bottom: solid 2px #000000 !important;"
                                >{{$t('modalpolicy.pol9')}}</p>
                                 {{$t('modalpolicy.pol10')}}
                              </div>
                              <div class="tab-pane fade" id="v-pills-alt" role="tabpanel" aria-labelledby="v-pills-alt-tab">
                                <p 
                                class="titletermsmodal"
                                style="border-bottom: solid 2px #000000 !important;"
                                >{{$t('modalpolicy.pol11')}}</p>
                                 {{$t('modalpolicy.pol12')}}
                              </div>
                              <div class="tab-pane fade" id="v-pills-rap" role="tabpanel" aria-labelledby="v-pills-rap-tab">
                                <p 
                                class="titletermsmodal"
                                style="border-bottom: solid 2px #000000 !important;"
                                >{{$t('modalpolicy.pol13')}}</p>
                                 {{$t('modalpolicy.pol14')}}
                              </div>
                            </div>
                          </b-col>
                        </b-row>
                      </div>
                    </div>
                  </div>
                </div>
                <!--  -->
            <button
              class="btnnavmob"
              >
              <span class="dinregular">total:</span>
              <span class="dinregular">US$</span>
              <span v-if="calculo.length == 0" class="dinregular">0.00</span>
              <span v-else class="dinregular">{{calculo.detalle.total}}</span>
            </button>
          </b-navbar>
        </div>
        
        <!-- modal for policies -->
                <div 
                class="modal fade" 
                id="policiesModal" 
                tabindex="-1" 
                aria-labelledby="policies-modal" 
                aria-hidden="true">
                  <div class="modal-dialog modal-xl">
                    <div class="modal-content rounded-0">
                      <div 
                      class="modal-header rounded-0" 
                      style="background-color:#169a5a;">
                        <h5 class="modal-title modaltitle" id="policies-modal">{{$t('modalpolicy.pol1')}}</h5>
                        <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close">
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </div>
                      <div class="modal-body">
                        <b-row>
                          <b-col md="5">
                              <div style="margin-top:-17px"  class="nav flex-column " id="v-pills-tab" role="tablist" aria-orientation="vertical">
                                <a class="btnpolicies nav-link active" id="v-pills-1-tab" data-toggle="pill" href="#v-pills-1" role="tab" aria-controls="v-pills-1" aria-selected="true">
                                  <p class="ml-3">{{$t('modalpolicy.pol2')}}
                                  </p>
                                </a>
                                <a class="btnpolicies nav-link" id="v-pills-2-tab" data-toggle="pill" href="#v-pills-2" role="tab" aria-controls="v-pills-2" aria-selected="false">
                                  <p class="ml-3">{{$t('modalpolicy.pol3')}}
                                  </p>
                                </a>
                                <a class="btnpolicies nav-link" id="v-pills-3-tab" data-toggle="pill" href="#v-pills-3" role="tab" aria-controls="v-pills-3" aria-selected="false">
                                  <p class="ml-3">{{$t('modalpolicy.pol5')}} 
                                  </p>
                                </a>
                                <a class="btnpolicies nav-link" id="v-pills-4-tab" data-toggle="pill" href="#v-pills-4" role="tab" aria-controls="v-pills-4" aria-selected="false">
                                  <p class="ml-3">{{$t('modalpolicy.pol7')}}
                                  </p>
                                </a>
                                <a class="btnpolicies nav-link" id="v-pills-5-tab" data-toggle="pill" href="#v-pills-5" role="tab" aria-controls="v-pills-5" aria-selected="false">
                                  <p class="ml-3">{{$t('modalpolicy.pol9')}}
                                  </p>
                                </a>
                                <a class="btnpolicies nav-link" id="v-pills-6-tab" data-toggle="pill" href="#v-pills-6" role="tab" aria-controls="v-pills-6" aria-selected="false">
                                  <p class="ml-3">{{$t('modalpolicy.pol11')}}
                                  </p>
                                </a>
                                <a class="btnpolicies nav-link" id="v-pills-7-tab" data-toggle="pill" href="#v-pills-7" role="tab" aria-controls="v-pills-7" aria-selected="false">
                                  <p class="ml-3">{{$t('modalpolicy.pol13')}}
                                  </p>
                                </a>
                              </div>
                          </b-col>
                          <b-col md>
                            <div class="tab-content" id="v-pills-tabContent">
                              <div class="tab-pane fade show active" id="v-pills-1" role="tabpanel" aria-labelledby="v-pills-1-tab">
                                <p 
                                class="titletermsmodal"
                                style="border-bottom: solid 2px #000000 !important;"
                                >{{$t('modalpolicy.pol2')}}</p>
                                <renttermscomp/>
                              </div>
                              <div class="tab-pane fade" id="v-pills-2" role="tabpanel" aria-labelledby="v-pills-2-tab">
                                <p 
                                class="titletermsmodal"
                                style="border-bottom: solid 2px #000000 !important;"
                                >{{$t('modalpolicy.pol3')}}</p>
                               {{$t('modalpolicy.pol4')}}
                              </div>
                              <div class="tab-pane fade" id="v-pills-3" role="tabpanel" aria-labelledby="v-pills-3-tab">
                                <p 
                                class="titletermsmodal"
                                style="border-bottom: solid 2px #000000 !important;"
                                >{{$t('modalpolicy.pol5')}} </p>
                                {{$t('modalpolicy.pol6')}}
                              </div>
                              <div class="tab-pane fade" id="v-pills-4" role="tabpanel" aria-labelledby="v-pills-4-tab">
                                <p 
                                class="titletermsmodal"
                                style="border-bottom: solid 2px #000000 !important;"
                                >{{$t('modalpolicy.pol7')}}</p>
                                {{$t('modalpolicy.pol8')}}
                              </div>
                              <div class="tab-pane fade" id="v-pills-5" role="tabpanel" aria-labelledby="v-pills-5-tab">
                                <p 
                                class="titletermsmodal"
                                style="border-bottom: solid 2px #000000 !important;"
                                >{{$t('modalpolicy.pol9')}}</p>
                                {{$t('modalpolicy.pol10')}}
                              </div>
                              <div class="tab-pane fade" id="v-pills-6" role="tabpanel" aria-labelledby="v-pills-6-tab">
                                <p 
                                class="titletermsmodal"
                                style="border-bottom: solid 2px #000000 !important;"
                                >{{$t('modalpolicy.pol11')}}</p>
                                {{$t('modalpolicy.pol12')}}
                              </div>
                              <div class="tab-pane fade" id="v-pills-7" role="tabpanel" aria-labelledby="v-pills-7-tab">
                                <p
                                class="titletermsmodal"
                                style="border-bottom: solid 2px #000000 !important;"
                                >{{$t('modalpolicy.pol13')}}</p>
                                {{$t('modalpolicy.pol14')}}
                              </div>
                            </div>
                          </b-col>
                        </b-row>
                      </div>
                    </div>
                  </div>
                </div>
              
    </div>
</template>
<script>
import renttermscomp      from '@/components/renttermscomp.vue'
import {mapState} from 'vuex'
export default {
    name: 'navbarreserve',
    components: {
        renttermscomp
    },
    
    computed: {
      //...mapState('reserva', ['data', 'calculo', 'subTotal', 'itbms']), // borrar luego
      ...mapState('reservav2', ['data', 'detalles', 'calculo']),
    },
    data(){
      return{
        hover: false,
      }
    }
}
</script>

<style  scoped>
@font-face {
    font-family: 'DIN 2014-ExraBold';
    src: url('../assets/fonts/DIN2014-ExtraBold.ttf');

}
@font-face {
    font-family: 'DIN 2014-Regular';
    src: url('../assets/fonts/DIN2014-Regular.ttf');
}

.btn-group-policy .button {
  background-color: #4CAF50; /* Green */
  border: 1px solid green;
  color: white;
  text-align: center;
  text-decoration: none;
  font-size: 16px;
  cursor: pointer;
  width: 100%;
  display: block;
  margin-left: -16px;
  
}

.btn-group-policy .button:not(:last-child) {
  border-bottom: none; /* Prevent double borders */
}

.btn-group-policy .button:hover {
  background-color: #3e8e41;
}
.mobilenav{
    background-color: #169A5A;
    height: 60px;
    border: none;
}
.iconlogo{
    height: 62px;
    width: 62px;
    
    margin-left: -15px;
    margin-top: -15px;
}
.btnnavmob{
    background-color: #15804d;
    height: 59px !important;
    width: 95px;
    font-size: 12.8px;
    font-weight: 300;
    margin-top: -12px !important;
    border: none !important;
    border-left: 1px solid #006639 !important;
    color: white;
    outline: none;
    position:absolute;
    right:0px;
}
.btnnavmob:active {
    border: left 1px solid rgb(18, 19, 18) !important;
    background-color: #181918;
}
.btnnavmob:focus {
    border: left 1px solid rgb(18, 19, 18) !important;
    background-color: #181918;
}
.titletermsmodal{
  color: #181918; 
  font-family: 'DIN 2014-Regular', Arial, sans-serif;
  font-size: 26px;
  font-weight: 600;
 /*  height: 52px;
  line-height: 28px;
  margin: 0px 0px 28px;
  padding: 0px 0px 21px;
  width: 788px; */
}
.cardtotals{
  border-radius: 0%;
  background-color: #181918;
  width: 525px;
  /* padding-left: 10%; */
 /*  margin-left: 39.92%; */
  right: 60px;
  transition: none !important;
  position: absolute;
  z-index: 1000;
}
.tooltip-inner {
   width: 100px !important;
   max-width:100px !important;
}
.tooltip-wide + .tooltip > .tooltip-inner {
     max-width: 100%;
}
.popover.b-popover
 {
  min-width: 400px !important;
  min-width: 250px !important;
  background: rgb(0, 0, 0) !important;
}
.iconpolicy{
  width: 10px;
  height: 20px;
  position:absolute;
  right:40px;
}
.dinregular{
  font-family: 'DIN 2014-Regular';
}
.dinbold{
  font-family: 'DIN 2014-ExraBold';
}
.modaltitle{
  font-family: 'DIN 2014-Regular';
  font-size: 16px;
  color: #fff;
}
.totalnav{
   color: #ffffff; 
   font-family: 'DIN 2014-Regular', Arial, sans-serif;
   font-size: 35px;
   font-weight: 300;
   height: 46px;
}
.tabspolicies{
  margin-left: -10px;
}
.popovertotal{
  font-family: 'DIN 2014-Regular', Arial, sans-serif;
  background: rgb(0, 0, 0) !important;
  color: #fff !important;
  width: 350px !important;
}

.supportside{
  background-color: rgb(235, 235, 235);
  
}

.cardterms{
  background-color: #15804d;
  padding: 3px 10px 0 10px;
  color: white;
  font-weight: 700;
}
.cartitle{
   color: #ffffff; 
   font-family: 'DIN 2014-Regular', Arial, sans-serif;
   font-size: 25px;
   font-weight: 400;
   height: 29px;
   line-height: 29.1667px;
}
.listgroup{
  border-top: none;
  border-left: none;
  border-right: none;
}
.supporticons{
    height: 50px;
    width: 50px;
    margin-bottom: 15px;
    margin-top: 30px;
}
.titlesection{
  font-family: 'DIN 2014-Regular', Arial, sans-serif;
   
   color: #333333;
   font-weight: 600;
   margin-bottom: 15px;
}
.titlesupp{
   font-family: 'DIN 2014-Regular', Arial, sans-serif;
   font-size: 18px;
   color: #169a5a;
   font-weight: 600;
   margin-bottom: 15px;
}
.textdetailstotals{
   font-family: 'DIN 2014-Regular', Arial, sans-serif;
   font-size: 15px;
   color: #169a5a;
   font-weight: 600;
   margin-bottom: 15px;
}
.focusborder:focus {
  outline: 2px solid #a4ceff !important;
}
.textsupp{
   font-family: 'DIN 2014-Regular', Arial, sans-serif;
   font-size: 18px;
   color: #169a5a;
}
.wrapper {
    min-height: 100%;
    height: auto !important;
    margin: 0 auto -30px;
    padding: 0 0 30px 0px;   /* new padding */
}
.collapsing {
  transition: none !important;
}
.titlequestion{
   font-family: 'DIN 2014-ExraBold', Arial, sans-serif;
   font-size: 32px;
   margin-top: 15px;
   margin-left: 30px;
   font-weight: 800;
   color: #181918;
}
.questions{
    font-family: 'DIN 2014-Regular', Arial, sans-serif;
    margin-left: 32px;
    line-height: 40px;
    color: #169a5a;
    font-size: 17px;
    font-weight: 500;
    text-decoration: none;
    margin: 0px;
    padding: 0px;
}
.questions:hover {
  color: #006639 !important;
}
.questions:focus {
  outline: 2px solid #a4ceff !important;
}
.navlinks{
    border-bottom: solid 0.05px rgb(185, 185, 185);
    
}
.navtext{
    font-family: 'DIN 2014-Regular', Arial, sans-serif;
    color: #169a5a !important;
    font-size: 14px;
    font-weight: 300;
}
.navtext2{
    font-family: 'DIN 2014-Regular', Arial, sans-serif;
    color: #686e6b !important;
    font-size: 14px;
    font-weight: 300;
}
.button{
  font-family: 'DIN 2014-ExraBold', Arial, sans-serif;
  Color: #FFFFFF;
  Size: 14px;
  letter-spacing: 0.9px;
  font-weight: 600;
  Text-align: center;
  Text-transform: uppercase;
  Background: #169A5A;
  Height: 33px;
  border: none;
}
.button:hover{
  Background:#006639;
}
.buttonterms{
  font-family: 'DIN 2014-ExraBold', Arial, sans-serif;
  Color: #FFFFFF;
  font-size: 14px;
  font-weight: 600;
  Text-align: center;
  Text-transform: uppercase;
  Background: #15804d;
  Height: 22px;
  border: none;
  padding-top: 1px;
}
.buttonterms:hover{
  Background:#15804d;
}
.noline{
  text-decoration: none;
}

.nav1{
    background-color: #169A5A;
    height: 70px;
    border: none;
}
.logo{
    height: 35px;
    width: 168px;
    border: 1px solid #fff;
    margin-left: 44px;
    margin-top: -5px;
}
.flag{
    height: 25px;
    width: 35px;
    border: 0.02px solid #fff;
    margin-left: 24px;
    margin-top: -5px;
}


/* ///////////////////////////////////////// */
.policytabs{
  background-color: #f3f3f3 !important;
  color: #169A5A !important; /*  text */
  /* margin-left: -16px !important;
  margin-top: -10px; 
  border: none;*/
  width: 100% !important;
  height: 40px !important;
}

.btnpolicies{
  font-family: 'DIN 2014-Regular', Arial, sans-serif;
  font-size: 14px;
  background-color: #f3f3f3; /*  background */
  color: #169A5A !important; /*  text */
  cursor: pointer; /* Pointer/hand icon */
  border: none;
  width: 100% !important; /* Set a width if needed */
  height: 41px;
  display: block; /* Make the buttons appear below each other */
  margin-left: -16px;
  border-bottom: 1px solid #a3a4a5 !important;
  background: url("/img/arrowright.png") no-repeat right/10px ;
}
.btnpolicies .btnpolicies:not(:last-child) {
  border-bottom: none; /* Prevent double borders */
}

/* Add a background color on hover */
.btnpolicies:active {
  background-color: #15804d;
}
.btnpolicies:focus {
  background-color: #006639;
  outline: none !important;
  color: #fff !important;
}

/* //////////////////////---------------/////////////////// */
/* Tooltip container */
.tooltip1 {
  position: relative;
  display: inline-block;
  border-bottom: 1px dotted black; /* If you want dots under the hoverable text */
}

/* Tooltip text */
.tooltip1 .tooltiptext1 {
  visibility: hidden;
  width: 120px;
  background-color: #555;
  color: #fff;
  text-align: center;
  padding: 5px 0;
  border-radius: 6px;

  /* Position the tooltip text */
  position: absolute;
  z-index: 1;
  bottom: 125%;
  left: 50%;
  margin-left: -60px;

  /* Fade in tooltip */
  opacity: 0;
  transition: opacity 0.3s;
}

/* Tooltip arrow */
.tooltip1 .tooltiptext1::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: #555 transparent transparent transparent;
}

/* Show the tooltip text when you mouse over the tooltip container */
.tooltip1:hover .tooltiptext1 {
  visibility: visible;
  opacity: 1;
}
</style>
